<template>
  <BaseTemplate>
    <UserRegister class="register" />
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import UserRegister from '@/components/pages/UserRegister/UserRegister.vue';

export default {
  components: {
    BaseTemplate,
    UserRegister,
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: $tabletWidth) {
  .register {
    padding-top: 50px;
  }
}
</style>
